import { useEffect } from "react";
import { useDepositosStore } from "../hooks/useDepositosStore";
import deposito from "../api/deposito";

export const useDeposito = () => {
  const { depositos, setDepositos, depositoSeleccionado, setDepositoSeleccionado } = useDepositosStore();

  useEffect(() => {
    const cargarDepositos = async () => {
      try {
        const data = await deposito.getAllDepositos();
        setDepositos(data);

        // Si no hay uno seleccionado, tomar el primero
        if (!depositoSeleccionado && data.length > 0) {
          setDepositoSeleccionado(data[0]);
        }
      } catch (error) {
        console.error("Error al cargar depósitos:", error);
      }
    };

    // Solo cargar depósitos si la lista está vacía
    if (depositos.length === 0) {
      cargarDepositos();
    }
  }, [depositos.length, depositoSeleccionado, setDepositoSeleccionado, setDepositos]);

  return {
    depositos,
    depositoSeleccionado,
    setDepositoSeleccionado,
  };
};
